import { KeyValueStorage } from '@wemogy/reactbase';
/**
 * We persist the host information, because it is only on initial load part of the url
 * If the application does a reload during runtime, we can't get it from the url. Instead we take a look in the KeyValueStorage :)
 */
var officeEnvironmentCachedHostInformationKey = 'officeEnvironmentHostInformation';
var OfficeEnvironment = /** @class */ (function () {
    function OfficeEnvironment() {
        this.applicationType = this.getOfficeApplicationType();
    }
    Object.defineProperty(OfficeEnvironment.prototype, "isRunningInsideOfficeApp", {
        get: function () {
            return this.applicationType !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    OfficeEnvironment.prototype.getHostInformation = function () {
        var hostInformationFromQuery = new URLSearchParams(window.location.search).get('_host_Info');
        if (hostInformationFromQuery) {
            KeyValueStorage.set(officeEnvironmentCachedHostInformationKey, hostInformationFromQuery);
            return hostInformationFromQuery;
        }
        return KeyValueStorage.getSync(officeEnvironmentCachedHostInformationKey);
        // ToDo: maybe support this office online way: https://stackoverflow.com/questions/40688057/in-excel-online-officejs-api-is-not-passing-the-host-info-parameter-anymore-to/40963500#40963500
    };
    OfficeEnvironment.prototype.getOfficeApplicationType = function () {
        var _a;
        var applicationTypePart = (_a = this.getHostInformation()) === null || _a === void 0 ? void 0 : _a.split('$')[0];
        switch (applicationTypePart === null || applicationTypePart === void 0 ? void 0 : applicationTypePart.toLowerCase()) {
            case 'excel':
                return 'excel';
            case 'word':
                return 'word';
            case 'outlook':
                return 'outlook';
            default:
                return undefined;
        }
    };
    return OfficeEnvironment;
}());
export default new OfficeEnvironment();
//# sourceMappingURL=OfficeEnvironment.js.map